import { EventDto } from '@diritto/common/event/dtos/event.dto';
import { JsonLd } from 'app-components/common/JsonLd';
import { useMemo } from 'react';
import { configure } from 'utils/configure';
import { getFullUrl } from 'utils/url';

export const EventJsonLd = ({ event }: { event: EventDto }) => {
  const openImageUrl = `${configure.staticPrefix}/images/og/diritto-og.png?v=2`;
  const url = useMemo(() => getFullUrl(`/events/${event.id}`), [event.id]);

  return (
    <JsonLd
      data={{
        '@context': 'http://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://google.com/article',
        },
        headline: event.title,
        image: [openImageUrl],
        url,
        description: event.description,
      }}
    />
  );
};
